import { Component, OnInit } from '@angular/core';
import { NavigationEnd, NavigationStart, Router } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import {
  MainLayoutService,
  PrgConfigHeader,
  PrgConfigSidebarMenu,
  TokenService,
} from 'prg-core-lib';
import { PrimeNGConfig } from 'primeng/api';
import {
  LANGUAGE_MENU_HEADER,
  SIDEBAR_MENU,
  USER_MENU_HEADER,
} from './menus-items-layout/menus-structure-layout';
import { QualipexHeaderService } from './layouts/services/qualipex-header.service';

@Component({
  selector: 'app-root',
  /*templateUrl: './app.component.html',*/
  template: `
    <ion-app>
      <router-outlet></router-outlet>
    </ion-app>
  `,
  styleUrls: ['./app.component.scss'],
})
export class AppComponent implements OnInit {
  constructor(
    private primeNGConfig: PrimeNGConfig,
    private translateService: TranslateService,
    private router: Router,
    private mainLayoutService: MainLayoutService,
    private qualipexHeaderService: QualipexHeaderService,
    private tokenService: TokenService
  ) {
    this.mainLayoutService.setSidebarConfig(
      new PrgConfigSidebarMenu({
        mainMenuItems: SIDEBAR_MENU,
      })
    );

    this.mainLayoutService.setHeaderConfig(
      new PrgConfigHeader({
        menuItemsUser: USER_MENU_HEADER,
        menuItemsLanguage: LANGUAGE_MENU_HEADER,
      })
    );
  }

  ngOnInit(): void {
    this.setupTranslateService();
    const config = this.router.config;
    config.push({
      path: '**',
      redirectTo: '',
      pathMatch: 'full',
    });
    this.router.resetConfig(config);

    this.router.events.subscribe((event: any) => {
      const activeWorkspaceIndex = event?.url?.indexOf('/active-workspace/');
      if (event instanceof NavigationStart && activeWorkspaceIndex !== -1) {
        const workspaceId = event.url.substring(
          activeWorkspaceIndex + '/active-workspace/'.length,
          event.url.length
        );
        if (workspaceId != null && workspaceId.length) {
          this.tokenService.getWorkspaceTokenByIdAsync(workspaceId);
        }
      }
      if (event instanceof NavigationEnd) {
        window.console.log(event);
        this.qualipexHeaderService.setDisplaySearchValue(false);
        this.mainLayoutService.setPageTitleActions([]);
        this.mainLayoutService.setPageTitleBackButtonUri(null);
        this.mainLayoutService.setPageTitle(null);
      }
    });
  }

  private setupTranslateService() {
    /// Configure translation service
    /// {
    // TODO: Get languages and default language from configuration

    this.translateService.langs = ['pt', 'en'];
    let currentLanguage = this.translateService.langs.includes(
      navigator.language
    )
      ? navigator.language
      : this.translateService.langs[0];

    let userLanguageSaved = JSON.parse(
      localStorage.getItem('qualipex-language-default')
    );
    if (userLanguageSaved != null) {
      currentLanguage = userLanguageSaved;
    }

    this.setUpLanguage(currentLanguage);
  }
  public setUpLanguage(currentLanguage: string) {
    this.translateService.setDefaultLang(currentLanguage);
    this.translateService.use(currentLanguage);
    this.translateService.onLangChange.subscribe((event: any) => {
      localStorage.removeItem('qualipex-language-default');
      localStorage.setItem(
        'qualipex-language-default',
        JSON.stringify(event?.lang)
      );
      this.translateService.get('primeng').subscribe((res) => {
        this.primeNGConfig.setTranslation(res);
      });
    });
  }
}
